import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { Switch } from '../ui/switch';
import { Send, Factory } from 'lucide-react';
import { format } from 'date-fns';

function BatchAssignDialog({ open, onClose, order, workCenters, onConfirm }) {
  const [workCenterId, setWorkCenterId] = useState('');
  const [startDateStr, setStartDateStr] = useState(() => format(new Date(), 'yyyy-MM-dd'));
  const [sameDay, setSameDay] = useState(false);

  const handleConfirm = () => {
    if (!workCenterId) return;
    onConfirm(workCenterId, new Date(startDateStr + 'T00:00:00'), sameDay);
  };

  const totalSteps = order?.items?.reduce(
    (sum, item) => sum + (item.steps?.filter((s) => !s.is_subcontracted).length || 0),
    0
  ) || 0;

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="w-[calc(100%-2rem)] sm:max-w-[420px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Send className="h-4 w-4" />
            工单全部分配
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 py-2">
          {order && (
            <div className="text-sm text-gray-600 space-y-1 bg-gray-50 p-3 rounded-md">
              <div><span className="font-medium">工单:</span> {order.production_order_number}</div>
              <div><span className="font-medium">客户:</span> {order.client_name}</div>
              <div><span className="font-medium">待分配工序:</span> {totalSteps} 个</div>
            </div>
          )}

          <div className="space-y-2">
            <Label>选择设备</Label>
            <Select value={workCenterId} onValueChange={setWorkCenterId}>
              <SelectTrigger>
                <SelectValue placeholder="选择设备..." />
              </SelectTrigger>
              <SelectContent>
                {workCenters.map((wc) => (
                  <SelectItem key={wc._id} value={wc._id}>
                    <div className="flex items-center gap-2">
                      <Factory className="h-3.5 w-3.5" />
                      {wc.name}
                      <span className="text-xs text-gray-400">({wc.work_center_id})</span>
                    </div>
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label htmlFor="start-date">起始日期</Label>
            <input
              id="start-date"
              type="date"
              value={startDateStr}
              onChange={(e) => setStartDateStr(e.target.value)}
              className="w-full h-9 px-3 rounded-md border border-input bg-transparent text-sm"
            />
          </div>

          <div className="flex items-center justify-between py-2">
            <div className="space-y-0.5">
              <Label className="text-sm">全部放到同一天</Label>
              <div className="text-xs text-gray-500">
                {sameDay ? '所有工序都分配到起始日期' : '工序按顺序分配到连续日期'}
              </div>
            </div>
            <Switch checked={sameDay} onCheckedChange={setSameDay} />
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>取消</Button>
          <Button onClick={handleConfirm} disabled={!workCenterId || !startDateStr}>
            确认分配
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default BatchAssignDialog;
